export default "__VITE_PUBLIC_ASSET__4398ec7b__"